<script>
import api from '@/helpers/api'
export default {
  name: 'product.other',
  props: {
    product_id: { type: String, required: true }
  },
  data: () => ({
    isLoading: false,
    product: {}
  }),
  mounted () {
    this.onInit()
  },
  watch: {
    product_id: { handler: 'onInit', immediate: true }
  },
  methods: {
    async onInit () {
      this.isLoading = true
      let item = await api.items.fetch({
        id: this.product_id
      })
      this.product = {
        ...item
      }
      this.isLoading = false
    },
    async onSave () {
      let valid = true

      if (valid) {
        const data = {
          ...this.product
        }

        try {
          this.isLoading = true
          let item = await api.items.update({
            ...data,
            id: this.product_id
          })
          this.$bvToast.toast(`Product info was saved!`, {
            title: 'Changes Saved',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 1000,
            appendToast: true
          })

          this.$parent.onInit()
          this.isLoading = false
        } catch (error) {
          this.isLoading = false

          this.$bvToast.toast(`${error}!`, {
            title: 'Error',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 1000,
            appendToast: true
          })
        }
      }
    }
  }
}
</script>
<template>
  <g-overlay :show="isLoading">
    <b-card>
      <h4 class="card-title">Other Options</h4>
      <b-form-group
        label="Default Status"
        label-for="product_default_status"
        label-cols-sm="3"
        label-cols-lg="2"
      >
        <b-form-input
          id="product_default_status"
          v-model="product.default_status"
          type="text"
          required
          autocomplete="product_default_status"
          placeholder="Order Item Status"
          :style="{ maxWidth: '350px' }"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label-for="is_discontinued"
        label-cols-sm="3"
        label-cols-lg="2"
      >
        <template v-slot:label> Discontinued </template>
        <b-form-checkbox
          switch
          size="lg"
          id="is_discontinued"
          v-model="product.is_discontinued"
          name="is_discontinued"
          class="py-2"
        ></b-form-checkbox>
      </b-form-group>

      <div class="d-flex justify-content-end">
        <b-btn class="btn-label" variant="primary" v-on:click="onSave">
          <i class="bx bx-save label-icon"></i>Save Changes
        </b-btn>
      </div>
    </b-card>
  </g-overlay>
</template>
